import { Component } from "react";
import "../styles/header.css";
import { Link } from "react-router-dom";
import { IoPersonCircle } from "react-icons/io5";

class Header extends Component {
  // Targets and deletes user key
  handleLogout = () => {
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  render() {
    const { isLoggedIn } = this.props;

    // Get User name from local storage
    let userEmail = "User";
    if (isLoggedIn) {
      try {
        const storedUserData = localStorage.getItem("user");
        if (storedUserData) {
          const parsedData = JSON.parse(storedUserData);
          if (parsedData.email) {
            userEmail = parsedData.email;
          }
        }
      } catch (error) {
        userEmail = "User Profile";
      }
    }

    return (
      <>
        <nav className="navbar navbar-expand-lg glass-navbar sticky-top shadow-sm py-3">
          <div className="container">
            <Link className="navbar-brand" to="/">
              <img
                src="/assets-webp/logos/xlp-logo.webp"
                alt="XLP Logo"
                height="50"
              />
            </Link>

            <button
              className="navbar-toggler border-0"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-3">
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/">
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link text-dark"
                    to="/xlp_for_schools_screen"
                  >
                    For Schools
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link text-dark"
                    to="/xlp_individual_students_screen"
                  >
                    For Individual Students
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link text-dark"
                    to="/channel_with_us_screen"
                  >
                    Channel with Us
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/xlp_workshops">
                    XLP Workshops
                  </Link>
                </li>

                {/* ─── PRODUCTS TAB HIDDEN (CEO request) ─────────────────────
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle text-dark"
                    to="/"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    Products
                  </Link>

                  {/* 1. MOBILE MENU *\/}
                  <ul className="dropdown-menu border-0 shadow d-lg-none mt-2">
                    <li>
                      <Link className="dropdown-item py-2" to="/shop_now_screen">
                        Shop Now
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item py-2" to="/">
                        Order History
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item py-2 d-flex justify-content-between"
                        to="/products_returns_screen"
                      >
                        Returns
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item py-2" to="/products_shipping_screen">
                        Shipping
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item py-2" to="/products_cancellation_screen">
                        Order Cancellation
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item py-2" to="/contact_screen">
                        Contact XLP
                      </Link>
                    </li>
                  </ul>

                  {/* 2. DESKTOP MENU *\/}
                  <div
                    className="dropdown-menu border-0 shadow-lg p-4 rounded-4 mega-menu d-none d-lg-block"
                    style={{ minWidth: "600px" }}
                  >
                    <div className="row g-4">
                      <div className="col-lg-6 d-flex flex-column gap-3">
                        <Link to="/shop_now_screen" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Shop Now</h6>
                          <p className="text-secondary small mb-0">Explore our latest curated products.</p>
                        </Link>
                        <Link to="/products_returns_screen" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Returns</h6>
                          <p className="text-secondary small mb-0">Simple and hassle-free return policy.</p>
                        </Link>
                        <Link to="/products_cancellation_screen" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Order Cancellation</h6>
                          <p className="text-secondary small mb-0">Cancel orders easily before dispatch.</p>
                        </Link>
                      </div>
                      <div className="col-lg-6 d-flex flex-column gap-3">
                        <Link to="/" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Order History</h6>
                          <p className="text-secondary small mb-0">View and track all past orders.</p>
                        </Link>
                        <Link to="/products_shipping_screen" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Shipping</h6>
                          <p className="text-secondary small mb-0">Fast, reliable delivery across regions.</p>
                        </Link>
                        <Link to="/contact_screen" className="text-decoration-none dropdown-custom-item">
                          <h6 className="text-dark fw-normal mb-1">Contact XLP</h6>
                          <p className="text-secondary small mb-0">Reach our team for assistance.</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
                ─── END PRODUCTS TAB ──────────────────────────────────── */}

                <li className="nav-item">
                  <Link className="nav-link text-dark" to="/contact_screen">
                    Contact Us
                  </Link>
                </li>
              </ul>

              <div className="d-flex gap-3 mt-3 mt-lg-0 align-items-center">
                {/* ─── DYNAMIC AUTH HIDDEN (CEO request) ───────────────────────
                {isLoggedIn ? (
                  <div className="dropdown">
                    <button
                      type="button"
                      className="btn border-0 p-0 bg-transparent d-flex align-items-center justify-content-center"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ cursor: "pointer", color: "#b54a2e" }}
                    >
                      <IoPersonCircle size={44} />
                    </button>

                    <ul
                      className="dropdown-menu dropdown-menu-end border-0 shadow mt-2 rounded-3 p-2"
                      style={{ minWidth: "220px" }}
                    >
                      <li className="px-3 py-2 text-center">
                        <span
                          className="d-block text-secondary small"
                          style={{ letterSpacing: "0.5px" }}
                        >
                          Signed in as
                        </span>
                        <span
                          className="d-block text-dark fw-medium text-truncate mt-1"
                          title={userEmail}
                        >
                          {userEmail}
                        </span>
                      </li>

                      <li>
                        <hr className="dropdown-divider opacity-25 my-2" />
                      </li>

                      <li>
                        <Link
                          className="dropdown-item py-2 text-center rounded-2"
                          to="/wip_screen"
                        >
                          Dashboard
                        </Link>
                      </li>

                      <li>
                        <button
                          type="button"
                          className="dropdown-item py-2 text-danger text-center rounded-2"
                          onClick={this.handleLogout}
                        >
                          Log out
                        </button>
                      </li>
                    </ul>
                  </div>
                ) : (
                  <Link
                    to="/sign_up_screen"
                    className="btn btn-link text-dark text-decoration-none"
                  >
                    Sign Up
                  </Link>
                )}
                ─── END DYNAMIC AUTH ─────────────────────────────────── */}

                <Link
                  to="/contact_screen"
                  className="btn btn-brand px-4 py-2 rounded-2"
                >
                  Request a Demo
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Header;
